import ScrollView from 'devextreme-react/scroll-view';
import './single-card.scss';
import { isKAB, isTCS, NODE_ENV } from 'app-constants';

interface Props {
  title:string,
  description?:string,
  children?: any,
  withLogo?: boolean,
  width?: string | number,
}

const getLogo = () => {
  if (isKAB) return '/atg-logo-128.png';
  if (isTCS) return '/tcs-logo.svg';
  if (NODE_ENV.startsWith('sub')) return '/otk-logo.svg';
  return '';
};

export const SingleCard = ({ title, description, children, withLogo, width='610px' }:Props) => <ScrollView
  height={'100%'}
  width={'100%'}
  className={'with-footer single-card'}
>
  <div className={'dx-card content'} style={{ width: width }}>
    <div className={'header'}>
      {withLogo && <img
        width='36' height='36' src={getLogo()} alt='blocked'
        style={{
          objectFit: 'contain',
          width: '36px',
          height: '36px',
        }} />}
      <div className={'title'}>
        {title}
      </div>
      <div className={'description'}>{description}</div>
    </div>
    {children}
  </div>
</ScrollView>;

